export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-burst-cf28b90fcf4ec317f1abca6301ed40a1.svg";